<div
  class="flex size-14 items-center justify-center rounded-full border border-[#F5F5F5]">
  <div class="size-6">
    <app-svg-icon
      [icon]="icon()"
      fill="#F5F5F5" />
  </div>
</div>
